'use client'

import { ChevronDownIcon, GlobusIcon } from '@fingertip/icons'
import i18next from 'i18next'
import { useRouter } from 'nextjs-toploader/app'
import { useTranslation as useTranslationI18N } from 'react-i18next'

import { LANGUAGES } from '@/lib/data/locales'
import { languages } from '@/lib/i18n/settings'

import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuPortal,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu'

export const PageNavbarLanguageSwitcher = () => {
  const { i18n } = useTranslationI18N()
  const currentLocale = i18n.language
  const router = useRouter()

  const handleChangeLanguage = (value: string) => {
    i18next.changeLanguage(value)
    router.refresh()
  }

  const current = LANGUAGES.find((item) => item.id === currentLocale)

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <div className="flex items-center gap-2 hover:text-primary transition-colors">
          <GlobusIcon className="size-4 shrink-0" />
          {current?.label || 'Select language'}
          <ChevronDownIcon className="size-4 shrink-0" />
        </div>
      </DropdownMenuTrigger>

      <DropdownMenuPortal>
        <DropdownMenuContent className="max-h-[250px] overflow-y-auto">
          {languages.map((lang) => {
            const current = LANGUAGES.find((item) => item.id === lang)

            return (
              <DropdownMenuCheckboxItem
                key={lang}
                onCheckedChange={() => handleChangeLanguage(lang)}
                checked={lang === currentLocale}
              >
                {current?.emoji} {current?.label}
              </DropdownMenuCheckboxItem>
            )
          })}
        </DropdownMenuContent>
      </DropdownMenuPortal>
    </DropdownMenu>
  )
}
